import { FirestoreDataConverter } from "@angular/fire/firestore";

export class DatabaseValue {
  code = '';
  value = '';
  option: DatabaseOption | null = null;
}

export class DatabaseOption {
  name: string;
  code: string;
}

export class DatabaseAllowedValue {
  value: string;
  code: string;
}

export class DatabaseProductStep {
  option: DatabaseOption;
  allowedValues: DatabaseAllowedValue[];
  hide: boolean;
  validations: { value: string, type: 'min' | 'max' | 'min_width' | 'max_width' | 'min_height' | 'max_height' }[] = [];
}

export class DatabaseProduct {
  id: string;
  code: string;
  name: string;
  apiDescription: string;
  images: string[];
  stepsOptions: DatabaseProductStep[];
  inputOptions: DatabaseProductStep[];
  treeOptionValuesMapping: any;

  constructor(production?: Partial<DatabaseProduct>) {
    this.id = production?.id ?? '';
    this.code = production?.code ?? '';
    this.name = production?.name ?? '';
    this.apiDescription = production?.apiDescription ?? '';
    this.images = production?.images ?? [];
    this.stepsOptions = production?.stepsOptions ?? [];
    this.inputOptions = production?.inputOptions ?? [];
    this.treeOptionValuesMapping = production?.treeOptionValuesMapping ?? '{}';
  }

  static converter: FirestoreDataConverter<DatabaseProduct> = {
    toFirestore: () => {
      throw Error();
    },
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new DatabaseProduct({
        ...data,
        id: snapshot.id
      });
    }
  }
}
